import * as React from 'react';
import { cn } from '@/lib/utils';

export interface AuthInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  label?: string;
}

const AuthInput = React.forwardRef<HTMLInputElement, AuthInputProps>(
  ({ className, label, error, id, ...props }, ref) => {
    return (
      <div className="space-y-2">
        {label && (
          <label
            htmlFor={id}
            className="block text-[14px] font-medium text-[#0d0d0d]"
          >
            {label}
          </label>
        )}
        <input
          id={id}
          className={cn(
            'flex h-[52px] w-full rounded-[12px] border bg-transparent px-4 py-3 text-[16px] text-[#0d0d0d] transition-colors',
            'placeholder:text-[#cecdc8]',
            'focus:border-[#2197f1] focus:outline-none focus:ring-0',
            'disabled:cursor-not-allowed disabled:opacity-50',
            error
              ? 'border-[#ff9196] focus:border-[#ff5b63]'
              : 'border-[#eeeeee]',
            className
          )}
          ref={ref}
          {...props}
        />
      </div>
    );
  }
);
AuthInput.displayName = 'AuthInput';

export { AuthInput };
